import { getConsumer } from "@/lib/cable";
import type { Announcement } from "@/types";

// Subscribe to global announcements for all logged-in users
export function subscribeAnnouncements(onReceive: (msg: Announcement) => void) {
  console.debug("[Announcements] Subscribing to AnnouncementsChannel");
  const sub = getConsumer().subscriptions.create(
    { channel: "AnnouncementsChannel" },
    {
      initialized() {
        console.debug("[Announcements] Subscription initialized");
      },
      connected() {
        console.debug("[Announcements] Connected to AnnouncementsChannel");
      },
      disconnected() {
        console.debug("[Announcements] Disconnected from AnnouncementsChannel");
      },
      rejected() {
        console.warn("[Announcements] Subscription rejected by server");
      },
      received: (data: Announcement) => {
        console.debug("[Announcements] Received:", data);
        onReceive(data);
      },
    },
  );
  return () => {
    console.debug("[Announcements] Unsubscribing from AnnouncementsChannel");
    sub.unsubscribe();
  };
}
